module.exports = __webpack_public_path__ + "img/top.aebd71f9.png";